import { apiGet } from '@/shared/utils/requestBuilder';
import { parseApiResponse } from '@/shared/utils/apiResponse';
import type { DashboardLexiData } from '../../types/dashboardLexi';

export interface DashboardLexiParams {
  escritorioId?: string;
  periodo?: string;
  dataInicio?: string;
  dataFim?: string;
}

const BASE_URL = '/admin/negociacoes/dashboard';

export const dashboardLexiService = {
  async get(params: DashboardLexiParams = {}): Promise<DashboardLexiData> {
    const query: Record<string, string> = {};
    if (params.escritorioId) query.escritorioId = params.escritorioId;
    if (params.periodo) query.periodo = params.periodo;
    if (params.dataInicio) query.dataInicio = params.dataInicio;
    if (params.dataFim) query.dataFim = params.dataFim;
    const response = await apiGet(BASE_URL, query);
    return parseApiResponse<DashboardLexiData>(response);
  },
};
